export default {
    translations: {
        home: {
            jumbotron_heading: "StarPro is especialist in",
            jumbotron_subtitle: "Urban Pest Control",
            jumbotron_text: "A leading company in the market, specialized in providing services in Urban Pest Control, Water Tank Sanitation, Environmental Sanitation and Plant Sanitation.",
            floating_container_text_black: "StarPro performs Phytosanitary Treatment, Pest Control, Sanitation of Environments, ",
            floating_container_text_green: "with excellence and professionalism.",
            first_card_title: "StarPro is present throughout Bahia…",
            first_card_text_black_slice_1: "A market",
            first_card_text_green: "leader company, recognized for its high quality standard. ",
            first_card_text_black_slice_2: "We are present in more than 7 cities and throughout the Metropolitan Region of Salvador, providing quality and responsible service for everyone.",
            second_card_title_first_line: "Certificate of",
            second_card_title_second_line: " Regional Councils",
            second_card_title_third_line: " of Chemistry and Biology",
            second_card_text: "All within the standards to better serve you. StarPro's purpose is to provide a quality and safety service, providing customer satisfaction and sustainable development.",
            banner_bottom_text_green: "Talk to a StarPro expert",
            banner_bottom_text_black: "We are ready to serve you"
        },
        header: {
            home: "Home",
            services: "Services",
            starpro: "StarPro",
            contact: "Contact"
        },
        services: {
            heading: "Our Services",
            phytosanitary_treatment_card_title: "Phytosanitary Treatment",
            phytosanitary_treatment_card_text: "StarPro phytosanitary has the knowledge, quality products, capacity and equipment to carry out phytosanitary treatment in a wide range of structures. Pest control in international trade safely and effectively.",
            urban_pest_control_card_title: "Urban Pest Control",
            urban_pest_control_card_text: "StarPro Urban Pest Control is essential for Environmental Health, since pests and vectors, in addition to creating annoyance, can also transmit numerous diseases.",
            water_tank_cleaning_and_disinfection_card_title: "Water Tank Cleaning and Disinfection",
            water_tank_cleaning_and_disinfection_card_text: "Cleaning of drinking water reservoirs, according to ANVISA, it must be sanitized every 06 months to prevent the proliferation of microorganisms that compromise the potability of water.",
            sanitization_of_environments_card_title: "Sanitization of Environments",
            sanitization_of_environments_card_text: "From the use of special techniques, with equipment and selected and safe products, StarPro fights viruses, fungi and bacteria in the most diverse environments, making them safer for your use. Sanitization? Call StarPro!",
            plant_sanitation_card_title: "Plant Sanitation",
            plant_sanitation_card_text: "The presence of vegetation in urban areas requires periodic maintenance, avoiding landscape discomfort, accumulation of waste, shelter for rodents and insects harmful to human health and domestic animals."
        },
        about_starpro: {
            heading: "About StarPro",
            card_title: "StarPro is an Environmental Health company that specializes in providing services in Urban Pest Control, Water Tank Sanitation, Phytosanitary Treatment and among others.",
            public_quality_item_title: "Public",
            public_quality_item_subtitle_first_line_number: "8",
            public_quality_item_subtitle_first_line_text: " thousand",
            public_quality_item_subtitle_second_line: "services provided",
            public_quality_item_text: "We reach and generate security for thousands of people in Bahia and Brazil.",
            where_do_we_worl_quality_item_title: "Where do we worl?",
            where_do_we_worl_quality_item_subtitle_first_line: "All arround ",
            where_do_we_worl_quality_item_subtitle_second_line: "Bahia",
            where_do_we_worl_quality_item_text: "We are present in Companies, Colleges, Stores, Markets throughout the State of Bahia",
            services_quality_item_title: "Services",
            services_quality_item_subtitle_first_line_number: "6",
            services_quality_item_subtitle_second_line_text: "Services",
            services_quality_item_text: "We operate in the most diverse segments, a complete structure to better serve you.",
            rating_quality_item_title: "Rating",
            rating_quality_items_subtitle_number: "5",
            rating_quality_items_subtitle_text: " stars",
            rating_quality_item_text: "Maximum rating in Google.",
            header_title: "About StarPro",
            header_text: "StarPro is recognized in the market for its high quality standard.",
            first_section_first_paragraph: "We are a company that proposes to offer better quality in all our services, valuing and respecting our team, guaranteeing well-being and safety for all.",
            first_section_seconcd_paragraph: "This is our purpose as a company, which believes in everyone who is directly or indirectly part of StarPro. Environmental Safety and Health starts here!",
            banner_bottom_title: "Heat treatment is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        international_certifications: {
            title: "International Certifications",
            first_paragraph_text: "We have certifications such as: ISO-9001 - GAFTA - FOSFA - NPMA. We offer complete security from the beginning to the end of the process on the necessary documentation with action reports.",
            second_paragraph_text_black: "StarPro is recognized by the market for its ",
            second_paragraph_text_green: "high quality standard."
        },
        quality_of_service: {
            title: "Quality of service and experience that earned the trust of our clients",
            text: "A little bit of who has been hiring StarPro and what they think about our service."
        },
        testimonials: {
            testimonial_author_1: "Tiago Botelho",
            testimonial_author_role_1: "Managing Partner Saneando Engenharia",
            testimonial_text_1: "From service to completion of the service they were extremely professional!",
            testimonial_author_2: "Maodisom Xavier",
            testimonial_text_2: "Excellent service company, with quality conduct, procedure and professionalism and application of products in a technical, safe and dynamic way.",
            testimonial_author_3: "Evelin Lisboa",
            testimonial_text_3: "Excellent service! Team committed to bringing well-being and safety through pest control. I recommend!",
            testimonial_author_4: "Fábio Müller",
            testimonial_author_role_4: "Operations Manager at VBR Logística",
            testimonial_text_4: "Professional and attentive staff!",
            testimonial_author_5: "Rosana Fialho",
            testimonial_text_5: "Wonderful experience. Very professional and correct company. Congratulations."
        },
        our_customers: {
            heading: "Customers who trust StarPro"
        },
        starpro_phytosanitary_treatment: {
            header_title: "StarPro Phytosanitary Treatment",
            header_text: "Specialist in pest control to ensure your loads stay safe.",
            first_section_header_title: "Pest control through efficient techniques and high quality products",
            first_section_first_article_header: "Heat Treatment",
            first_section_first_article_first_paragraph: "Thermal treatments are a great option as they do not harm nature.",
            first_section_first_article_second_paragraph: "Temperature directly affects the physiology of an insect. By changing the temperature, you can change an insect's metabolism, breathing, and movement. That's why heat treatments work very well to carry out pest control in loads.",
            first_section_second_article_header: "Fumigation",
            first_section_second_article_first_paragraph: "Phosphine (PH3) fumigation is very effective and widely used for fumigation of stored grain. It is approved for application in raw agricultural products, processed foods, animal feed and its ingredients, tobacco and other non-food items.",
            first_section_second_article_second_paragraph: "Fumigation with Methyl Bromide is extremely efficient and very important for countries that value their natural diversity. It is a product with a broad spectrum of action and extremely efficient operability for containerized cargo.",
            banner_bottom_title: "Heat treatment is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        business_security: {
            title: "Safety for international trade: your wood free from pests",
            sea_ports_card_title: "Sea ports",
            airports_card_title: "Airports",
            ships_card_title: "Ships",
            warehouses_card_title: "Warehouses",
            container_card_title: "Container"
        },
        urban_pest_control: {
            header_title: "Urban Pest Control",
            header_text: "Specialist in pest control to ensure your safety and comfort.",
            first_section_header_title: "Urban Pest Control is with StarPro!",
            first_section_first_paragraph: "The control of pests and vectors in urban areas is a matter of environmental health.",
            first_section_second_paragraph: "For each type of pest, a specific and effective treatment carried out by a team of specialists in the segment. Get long-term pest control with real results.",
            first_section_third_paragraph: "Mosquitoes, flies, ants, rats, termites and cockroaches, in addition to being unpleasant, can transmit numerous diseases with disastrous consequences for humans. And it can happen in any kind of environment, like your home or place of work.",
            second_section_title: "How can StarPro Pest Control help keep your environment safer?",
            second_section_first_paragraph: "A leading company in the market, specialized in providing services in Urban Pest Control, Water Tank Sanitation, Environmental Sanitization and Plant Sanitation.",
            second_section_second_paragraph: "StarPro is recognized in the market for its high quality standard.",
            second_section_third_paragraph: "Urban environments are susceptible to the proliferation of pests, bringing economic and serious damages to human health. StarPro uses the most modern techniques with strategic applications ensuring a safe and secure environment.",
            banner_bottom_title: "Urban Pest Control is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        cleaning_and_disinfection_of_water_tanks: {
            header_title: "Cleaning and Disinfection of Water Tanks",
            header_text: "Specialist in cleaning water reservoirs.",
            first_section_header_title: "Vegetation control through efficient techniques and high quality products",
            first_section_first_article_header: "The Treatment",
            first_section_first_article_paragraph: "The cleaning of water reservoirs, according to ANVISA, must be sanitized every 06 months to avoid the proliferation of microorganisms that compromise the potability of water. This procedure consists of mechanical cleaning and chemical disinfection of the internal walls of the reservoir, in compliance with current legislation.",
            second_section_header_title: "How does StarPro make your environment safer through Cleaning and Disinfection?",
            second_section_text: "After an analysis carried out by StarPro specialists, professionals start the procedure using specialized techniques and products.",
            banner_bottom_title: "Water Tank Cleaning and Disinfection is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        about_us: {
            header_title: "About StarPro",
            header_text: "StarPro is recognized for its high quality standard.",
        },
        license_banner: {
            title: "StarPro is licensed by the sanitary surveillance and has the afe certificate, from Anvisa.",
            subtitle: "We are ready to guarantee the safety of your environments."
        },
        sanitization_of_environments: {
            header_title: "Sanitization of Environments",
            header_text: "Specialist in disinfection service against viruses, bacteria and fungi.",
            first_section_header_title: "The Treatment",
            first_section_text: "Sanitizing environments prevents the spread of bacteria and the virus that causes COVID-19, ensuring biological safety through the application of a sanitizing product by specialist technicians equipped with high-tech equipment, forming a protective film on all surfaces such as floors, walls, windows, furniture and high-contact structures (handrails, doorknobs, drawer and cabinet handles).",
            second_section_header_title: "How does StarPro make its environment safer through sanitization and disinfection?",
            second_section_first_paragraph: "After an analysis carried out by StarPro specialists, professionals start the procedure using specialized techniques and products.",
            second_section_second_paragraph: "Our team of experts solves the problem. It doesn't matter the size of the environment you are in. Count on our expertise in sanitization and disinfection. Your clean and safe environment for longer is our goal.",
            second_section_third_paragraph: "Your environment clean and safe.",
            item_condominiums: "Condominiums",
            item_houses: "Houses",
            item_restaurants: "Restaurants",
            item_industries: "Industries",
            item_hotels: "Hotels",
            item_hospitals: "Hospitals",
            banner_bottom_title: "Sanitization of Environments is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        plant_sanitation: {
            header_title: "Plant Sanitation",
            header_text: "Specialist in eliminating unwanted vegetation",
            first_section_header_title: "Pest control through efficient techniques and high quality products",
            first_section_first_paragraph: "We are a company that proposes to offer better quality in all our services, valuing and respecting our team, guaranteeing well-being and safety for all.",
            first_section_second_paragraph: "This is our purpose as a company, which believes in everyone who is directly or indirectly part of StarPro. Environmental Safety and Health starts here!",
            banner_bottom_title: "Plant Sanitation is with StarPro",
            banner_bottom_subtitle: "We are ready to serve you"
        },
        mission_vision_values: {
            mission_title: "Mission",
            mission_text: "Provide quality and safety services, providing customer satisfaction and sustainable development.",
            vision_title: "Vision",
            vision_text: "To be a reference in the provision of services, promoting the continuous development of processes, benefiting everyone.",
            values_title: "Values",
            values_list: [
                "Quality in service",
                "Credibility",
                "Organization",
                "Punctuality",
                "Respect for the environment"
            ]
        },
        buttons: {
            customers_area: "Customer's area",
            talk_to_us: "Talk to our experts",
            learn_more: "Learn more"
        },
        contact_form: {
            heading: "Contact",
            input_name_label: "Name",
            input_cell_number_label: "Cell number",
            input_email_label: "E-mail",
            select_quote_label: "Request quote",
            select_quote_default_option: "Choose a service",
            textarea_type_your_text_here: "Type your message here",
            message_sent: "Your message was sent. Soon we will contact you.",
            message_failed: "Failed to send message.",
            button: "Send",
        },
        form_validations: {
            required: "Required*",
            email_invalid: "Invalid e-mail.",
            phone_invalid: "Invalid phone number.",
            service_invalid: "Invalid service type."
        }
    }
}